import React from 'react';
import EntityTasks from '../../../shared/EntityTasks';
import {CustomerType} from '../../../../constants/EntityTypeNames';
import AlertBox from '../../../shared/AlertBox';
import LoadingBox from '../../../shared/LoadingBox';

export default class TasksListScreen extends React.Component {
    state = {
        customerID: 0,
        entityTasksSaveProcess: false,
        showAlert: false,
        alertTitle: '',
        alertMessage: '',
        loading: false,
    }

    onFinishEntityTasksSaveProcess(status,message){
        if(status){
            this.setState({entityPropertiesSaveProcess: false, showAlert: true, alertTitle: 'Success.', alertMessage: 'Customer Tasks saved.', loading: false, entityTasksSaveProcess: false});
        }else{
            this.setState({entityPropertiesSaveProcess: false, showAlert: true, alertTitle: 'Error', alertMessage: message, loading: false, entityTasksSaveProcess: false});
        }
    }

    handleButtonSaveClick(){
        this.setState({entityTasksSaveProcess: true, loading: true});
    }

    closeAlert(){
        this.setState({showAlert: false, alertMessage: '', alertTitle: ''});
    }

    render() {
        return(
            <div>
                <form className="uk-form-stacked uk-grid">
                    <div className="uk-width-1-1 uk-margin">
                        <EntityTasks readOnly={this.props.readOnly} fullScreen={true} entityType={CustomerType} entityID={this.props.customerID} personID={this.props.personID} runSaveProcess={this.state.entityTasksSaveProcess} finishSaveProcess={this.onFinishEntityTasksSaveProcess.bind(this)} />
                    </div>
                    <div>
                        <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleButtonSaveClick.bind(this)} type="button" disabled={this.props.readOnly}>Save</button>                        
                    </div>
                </form>
                <AlertBox open={this.state.showAlert} onClose={this.closeAlert.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.closeAlert.bind(this)}/>
                <LoadingBox loading={this.state.loading}/>
            </div>
        );
    }
}